import React from "react";
import { MARQUEE_ITEMS } from "@/mock";

const TopBar = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="w-full bg-[#0b0b0c] text-[#e9d9b0] text-[12px] tracking-wide overflow-hidden border-b border-[#1c1c1e]">
      <div className="relative flex whitespace-nowrap py-2.5">
        <div className="flex animate-[marquee_35s_linear_infinite] gap-14 px-8">
          {items.map((t, i) => (
            <span key={i} className="inline-flex items-center gap-3">
              <span className="h-1 w-1 rounded-full bg-[#c9a24a]" />
              {t}
            </span>
          ))}
        </div>
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0);} to { transform: translateX(-50%);} }`}</style>
    </div>
  );
};

export default TopBar;
